import { Link } from 'react-router-dom';
import LanguageSwitcher from '../LanguageSwitcher/LanguageSwitcher';
import { buildBlogPath, DEFAULT_LANGUAGE } from '../../utils/languageUtils';
import './BlogBreadcrumb.css';

const BlogBreadcrumb = ({
  currentLang,
  category,
  localeVariants = [],
  sourceLanguage = DEFAULT_LANGUAGE,
  sourceSlug = '',
}) => (
  <nav
    className='blog-breadcrumb text-md sm:mb-0 md:mb-2 text-gray-500 xxxl:mx-10 xxs:mx-4'
    aria-label='breadcrumb'
  >
    <div className='blog-breadcrumb-links'>
      <Link to={buildBlogPath(currentLang)} className='hover:text-gray-700'>
        Blog
      </Link>
      {category && (
        <>
          <span className='mx-2'>/</span>
          <span className='text-gray-700 cursor-default'>{category}</span>
        </>
      )}
    </div>
    <LanguageSwitcher
      localeVariants={localeVariants}
      sourceLanguage={sourceLanguage}
      sourceSlug={sourceSlug}
      compact
    />
  </nav>
);

export default BlogBreadcrumb;
